import React, { useEffect, useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import WhatsAppButton from '../components/layout/WhatsAppButton';
import CategoryGateway from '../components/sections/CategoryGateway';
import { WhyUs, HowItWorks } from '../components/sections/StorySections';
import Projects from '../components/sections/Projects';
import Clients from '../components/sections/Clients';
import ContactCTA from '../components/sections/ContactCTA';
import { QuoteDialog } from '../components/Modals';
import { listItems } from '../api';

export default function Home() {
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    listItems('projects').then(setProjects).catch(() => {});
    listItems('clients').then(setClients).catch(() => {});
  }, []);

  return (
    <div className="bg-white min-h-screen" data-testid="home-page">
      <Header onQuote={() => setQuoteOpen(true)} />
      <CategoryGateway />
      <WhyUs />
      <HowItWorks />
      <Projects projects={projects} compact />
      <Clients clients={clients} />
      <ContactCTA onQuote={() => setQuoteOpen(true)} />
      <Footer />
      <WhatsAppButton />

      <QuoteDialog open={quoteOpen} onClose={() => setQuoteOpen(false)} prefillProduct={null} />
    </div>
  );
}
